import { isStandalone, isIos } from "./pwa";

export const REFRESH_KEY = "valiosia_refresh";

export function shouldPersistRefresh(win = typeof window === "undefined" ? undefined : window) {
  return Boolean(isStandalone(win) || isIos(win));
}

export function saveRefreshToken(raw, win = typeof window === "undefined" ? undefined : window) {
  if (!raw || !shouldPersistRefresh(win)) return;
  try { win.localStorage.setItem(REFRESH_KEY, raw); } catch { /* private mode */ }
}

export function loadRefreshToken(win = typeof window === "undefined" ? undefined : window) {
  if (!win) return null;
  try { return win.localStorage.getItem(REFRESH_KEY); } catch { return null; }
}

export function clearRefreshToken(win = typeof window === "undefined" ? undefined : window) {
  try { win?.localStorage?.removeItem(REFRESH_KEY); } catch { /* private mode */ }
}
